// Line chart simples — uma série, eixo X de labels, eixo Y formatado.
import { LineChart as RLineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ReferenceLine, ResponsiveContainer } from "recharts";
import { fmtNum } from "../../lib/format.ts";
import { chartTheme, tooltipStyle, defaultMargin } from "./theme.ts";

interface Marker {
  label: string;   // valor do X (deve bater com algum data[i].label)
  text: string;    // texto curto a exibir
  color?: string;
}

interface Props {
  data: Array<{ label: string; value: number; raw?: any }>;
  height?: number;
  formatValue?: (v: number) => string;
  color?: string;
  showDots?: boolean;
  markers?: Marker[];
}

export function LineChart({ data, height = 240, formatValue = fmtNum, color, showDots = true, markers }: Props) {
  if (!data.length) return <div className="center-loading">sem dados</div>;
  const t = chartTheme();
  const stroke = color ?? t.primary;

  return (
    <ResponsiveContainer width="100%" height={height}>
      <RLineChart data={data} margin={defaultMargin}>
        <CartesianGrid stroke={t.grid} strokeDasharray="3 3" vertical={false} />
        <XAxis
          dataKey="label"
          tick={{ fontSize: 10, fill: t.muted, fontFamily: "JetBrains Mono, monospace" }}
          axisLine={{ stroke: t.grid }}
          tickLine={false}
          interval="preserveStartEnd"
          minTickGap={20}
        />
        <YAxis
          tickFormatter={formatValue}
          tick={{ fontSize: 10, fill: t.muted, fontFamily: "JetBrains Mono, monospace" }}
          axisLine={false}
          tickLine={false}
          width={56}
        />
        <Tooltip {...tooltipStyle} formatter={(v) => [formatValue(v as number), ""]} />
        {(markers ?? []).map((m, i) => (
          <ReferenceLine
            key={i}
            x={m.label}
            stroke={m.color ?? "#b91c1c"}
            strokeDasharray="4 4"
            strokeWidth={1.5}
            label={{ value: m.text, position: "top", fill: m.color ?? "#b91c1c", fontSize: 11, fontWeight: 600 }}
          />
        ))}
        <Line
          type="monotone"
          dataKey="value"
          stroke={stroke}
          strokeWidth={2}
          dot={showDots ? { fill: stroke, r: 3 } : false}
          activeDot={{ r: 5 }}
        />
      </RLineChart>
    </ResponsiveContainer>
  );
}
